import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const meetTrainerRequestBase = () => ({ type: ACTION.MEETTRAINER_REQUEST_BASE });
export const meetTrainerRequestQuery = () => ({ type: ACTION.MEETTRAINER_REQUEST_QUERY });
export const isLibraryLoading = () => ({ type: ACTION.LIBRARY_LOADING });
export const libraryLoaded = (meettrainer_requests = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED, meettrainer_requests, totalCount, query });
export const meetTrainerRequestLoaded = (meettrainer_requests = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED, meettrainer_requests, totalCount, query });
export const isFilterLoading = () => ({ type: ACTION.FILTER_LOADING });
export const filterLoaded = (filters = {}) => ({ type: ACTION.FILTER_LOADED, filters });
export const meetTrainerRequestUpdating = () => ({ type: ACTION.MEETTRAINER_REQUEST_UPDATING });
export const meetTrainerRequestError = (error) => ({ type: ACTION.MEETTRAINER_REQUEST_ERROR, error });

export const getMeetTrainerRequestLibrary = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isLibraryLoading());
    apiService.getMeetTrainerRequestItems(params)
    .then(response => {
      dispatch(libraryLoaded(response?.results, response?.results.length));
      resolve(response);
    })
    .catch(error => {
      dispatch(meetTrainerRequestBase());
      reject(error);
    });
  });
}

export const addMeetTrainerRequestUpdating = (id, params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(meetTrainerRequestUpdating());
    apiService.createProgramSet(id, params)
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      dispatch(meetTrainerRequestError(error));
      reject(error);
    });
  });
}

export const getMeetTrainerRequestAggregate = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isFilterLoading());
    params.endpoint = 'meettrainer';
    apiService.getAggregate(params)
    .then(response => {
      const programState = getState().programState;
      let filters = Object.assign({}, programState.filters);
      filters[params.type] = response[params.type];
      dispatch(filterLoaded(filters));
      resolve(response);
    })
    .catch(error => {
      dispatch(meetTrainerRequestBase());
      reject(error);
    });
  });
}